<po-toaster
  class="po-md-12"
  [p-message]="alertMessage"
  [p-hide]="hideAlert"
  [p-type]="alertType"
  style="position: fixed; top: 0; left: 0; right: 0; z-index: 9999; width: 100%;"
></po-toaster>
